/* eslint-disable import/prefer-default-export */
import DashRenderjson from './components/DashRenderjson.react';

export {
    DashRenderjson
};
